var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0 -0.005 25.76 25.215",
    viewBox: "0 -0.005 25.76 25.215",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-kxyo45p8 svg [data-color=\"1\"] {fill: #CA9400;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.67 5.18a2.32 2.32 0 1 0-2.32-2.32 2.32 2.32 0 0 0 2.32 2.32m0-3.81a1.49 1.49 0 1 1-1.49 1.49 1.49 1.49 0 0 1 1.49-1.49",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.47 10 10.8a.41.41 0 0 0 .37.45.41.41 0 0 0 .41-.37L11 8.54a.42.42 0 0 0-.38-.45.42.42 0 0 0-.45.38",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.09a.42.42 0 0 0-.39.44l.13 2.33a.42.42 0 0 0 .42.39.41.41 0 0 0 .39-.43l-.13-2.34a.42.42 0 0 0-.42-.39",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85 15.37a.41.41 0 0 0-.41.42v9a.41.41 0 0 0 .41.42.42.42 0 0 0 .42-.42v-9a.42.42 0 0 0-.42-.42",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72 11.08h.07a.42.42 0 0 0 .41-.35l.54-3a1.87 1.87 0 0 1 1.37-1.51l.66-.22a.42.42 0 0 0-.2-.81l-.67.18a2.67 2.67 0 0 0-2 2.18l-.54 3a.42.42 0 0 0 .34.48",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.21a.42.42 0 0 0-.51.3.43.43 0 0 0 .3.51l.67.17a1.88 1.88 0 0 1 1.33 1.51l.53 3a.43.43 0 0 0 .41.34h.08a.42.42 0 0 0 .33-.48l-.53-3a2.68 2.68 0 0 0-2-2.18z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 8.42a.41.41 0 0 0-.47.35.42.42 0 0 0 .36.47c2.87.41 3.54 1 3.56 1.14s-.17.49-2.37.94a31.71 31.71 0 0 1-6.11.52 31.64 31.64 0 0 1-6.11-.52c-2.2-.45-2.37-.93-2.37-.94s.67-.72 3.49-1.13a.41.41 0 0 0 .35-.47.4.4 0 0 0-.47-.35 13.88 13.88 0 0 0-2.89.68c-.32.13-1.31.52-1.31 1.27s1 1.32 2.93 1.73c.48.11 1 .19 1.57.27l-.39 2.19A1.26 1.26 0 0 0 8.73 16h.19a1.24 1.24 0 0 0 1-.47l.85 9.26a.41.41 0 0 0 .41.37.41.41 0 0 0 .37-.45l-1-10.78.08-1a.22.22 0 0 0 0-.08v-.22c.71 0 1.44.05 2.18.05h2l.07 1.25-.8 10.77a.42.42 0 0 0 .38.45.42.42 0 0 0 .42-.39l.72-9.25a1.25 1.25 0 0 0 1 .47h.18a1.25 1.25 0 0 0 1.06-1.37l-.39-2.16q1-.12 1.8-.3c2-.41 2.93-1 2.93-1.73 0-.9-1.44-1.56-4.28-2m-8.58 6.4a.41.41 0 0 1-.47.33.42.42 0 0 1-.36-.45l.39-2.22 1 .08v.23l-.51 2M17 14.7a.43.43 0 0 1-.84.12l-.48-2a.14.14 0 0 0 0-.07v-.15l1-.08z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.64.83h3.54a.42.42 0 1 0 0-.83H.64a.42.42 0 1 0 0 .83",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.64 2.55h1.77a.41.41 0 0 0 .41-.42.41.41 0 0 0-.41-.41H.64a.41.41 0 0 0-.42.41.42.42 0 0 0 .42.42",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.34 0H21.8a.42.42 0 0 0-.42.42.41.41 0 0 0 .42.41h3.54a.41.41 0 0 0 .42-.41.42.42 0 0 0-.42-.42",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.57 1.72H21.8a.41.41 0 0 0-.42.41.42.42 0 0 0 .42.42h1.77a.42.42 0 0 0 .43-.42.41.41 0 0 0-.42-.41",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.89H.42a.41.41 0 0 0-.42.41.42.42 0 0 0 .42.42H4a.42.42 0 0 0 .42-.42.41.41 0 0 0-.42-.41",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.46a.42.42 0 0 0-.42.42v1.33a.4.4 0 0 0 .12.29l2.74 2.74a.42.42 0 0 0 .3.12.42.42 0 0 0 .29-.12.42.42 0 0 0 0-.59L1.91 5V3.88a.42.42 0 0 0-.41-.42",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3.46a.41.41 0 0 0-.41.42V5l-1.94 2a.4.4 0 0 0 0 .59.41.41 0 0 0 .58 0l2.06-2a.45.45 0 0 0 .12-.29V3.88a.42.42 0 0 0-.41-.42",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39 12.91 1 16.32a.42.42 0 0 0-.12.3v1.94a.41.41 0 0 0 .41.41.41.41 0 0 0 .42-.41v-1.77L5 13.5a.42.42 0 1 0-.59-.59",
    fill: "#E4A118",
    "data-color": 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step-4.6657bc481fc7685e52a5ac4ad80f42df.svg";
export { ForwardRef as ReactComponent };